module.exports = __webpack_public_path__ + "img/03.79dc597f.png";